export const emailIfElse = (cond: string, ifCond: string, elseCond: string) => {
  return `
    <% if(${cond}) { %>
      ${ifCond}
    <% } else { %>
      ${elseCond}
    <% } %>
  `;
};
